export default __webpack_public_path__ + "static/media/toiawase.834e665f.png";